import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { ClientsSettingsComponent } from './clients-settings/clients-settings.component';

const routes: Routes = [
  {
    path: 'settings',
    title: '',
    children: [
      {
        path: 'clients',
        title: 'settings.clients.title',
        component: ClientsSettingsComponent,
        canActivate: [ProfileGuard],
        data: { action: 'settings.clients' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {}
